import {Radio} from 'antd'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'

const CANONICAL_KEYS = ['Tenant', 'Site', 'Gateway', 'Camera', 'Target']

const TypeSelect = ({onChange, selected, isNew, terms}) => {
  const [options, setOptions] = useState([])
  const user = useSelector(state => state.auth.user)
  const tenant = useSelector(state => state.settings.tenant)

  useEffect(() => {
    let types = ['Site', 'Gateway', 'Camera', 'Target']
    if (user.role === 'sysadmin' && !tenant) types.unshift('Tenant')
    setOptions(types)
  }, [user, tenant, selected, isNew])

  const handleEvent = ({target: {value}}) => {
    onChange(value)
  }

  // Map canonical keys to display terms if provided
  const radioOptions = options.map(key => ({
    label: terms && terms[key.toLowerCase()] ? terms[key.toLowerCase()] : key,
    value: key
  }))

  return (
    <Radio.Group
      data-testid="type-select"
      className="type-select"
      options={radioOptions}
      onChange={handleEvent}
      value={selected}
      optionType="button"
      buttonStyle="solid"
    />
  )
}

export default TypeSelect
